import useStateHandler from '@/hooks/useStateHandler';
import Text from '@/shared-components/text/components/Text';

import './styles/Info.css';

export default function Info({
  verifiedCount = 0,
  required = 3,
  onBeginClick,
  onAddArtwork,
  canAddArtwork,
  paymentLoading,
  paymentHint,
  pricingPromo,
}) {
  const { state } = useStateHandler();
  const isReady = verifiedCount >= required;
  const hintText = paymentLoading
    ? 'Checking payment status…'
    : paymentHint ?? 'Add a payment method to unlock uploads.';

  return (
    <div className="verify-gallery__info-container">
      {/* Title */}
      <Text className="verify-gallery__welcome-text" paragraph>
        Welcome {state.user_session.user_name}!
      </Text>

      {/* Copy switches depending on verification */}
      {isReady ? (
        <Text className="verify-gallery__ready-text" paragraph>
          Everything’s ready. Click on <b>Begin my journey</b> below to access your Gallery Profile.
        </Text>
      ) : (
        <Text className="verify-gallery__subtitle-text" paragraph>
          You’re almost ready! Upload {required} artworks to unlock your Gallery Profile.
        </Text>
      )}

      {/* CTA switches */}
      {isReady ? (
        <button className="verify-gallery__add-artwork-btn" onClick={onBeginClick}>
          Begin my journey
        </button>
      ) : (
        <>
          <button
            type="button"
            className="verify-gallery__add-artwork-btn"
            onClick={onAddArtwork}
          >
            Add artwork
          </button>
          {!canAddArtwork && (
            <>
              {pricingPromo && (
                <div className="verify-gallery__payment-offer">
                  <span className="verify-gallery__payment-offer-note">
                    Pricing stays forever. Cancel anytime. Promo available until August 2026. 
                  </span>
                  <span className="verify-gallery__payment-offer-primary">
                    {pricingPromo.reducedLabel}
                  </span>
                  <span className="verify-gallery__payment-offer-secondary">
                    Standard {pricingPromo.standardLabel}
                  </span>
                </div>
              )}
              {!pricingPromo && (
                <p className="verify-gallery__payment-hint">
                  {hintText}
                </p>
              )}
            </>
          )}
          {/*
          {showResetSubscriptionButton && (
            <button
              type="button"
              className="verify-gallery__remove-subscription-btn"
              onClick={onResetSubscription}
              disabled={paymentLoading}
            >
              Remove subscription (testing)
            </button>
          )}
          */}
        </>
      )}
    </div>
  );
}
